// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/functions.css
// module id = 34
// module chunks = 0